module.exports = __webpack_public_path__ + "img/image (161).a37f780f.jpg";